<div class="pb-4" style="padding-left: 15px">
  <mat-slide-toggle
    (change)="onToggleStatistic($event)"
    checked="{{showStatistic}}">
    Show Statistic
  </mat-slide-toggle>
</div>

@for (item of combinedContent; track item) {
  @if (item.id != editBlockId) {
    <div class="edit-block"
         matTooltip="Click to edit"
         matTooltipClass='bp-tooltip'
         (click)="toggleEditBlock(item.id, $event)">
      <!-- List Items -->
      @for (el of item.translations[currentLanguage].content_rendered; track el) {
        @if (el.type === 'paragraph') {
          <app-block-style-paragraph [data]="el"></app-block-style-paragraph>
        }
        @if (el.type === 'header') {
          <app-block-style-header [data]="el"></app-block-style-header>
        }
        @if (el.type === 'list') {
          <app-block-style-list [data]="el"></app-block-style-list>
        }
        @if (el.type === 'table') {
          <app-block-style-table [data]="el"></app-block-style-table>
        }
        @if (el.type === 'image') {
          <app-simple-image [data]="el"></app-simple-image>
        }
      }
    </div>
  } @else {
    <app-block-style-editor
      [contentBlock]="item"
      [selectedLanguage]="editLanguage"
      [isEditMode]="true"
      (languageChange)="editLanguage = $event"
      (save)="updateEditorBlock(item)"
      (cancel)="toggleEditBlock(item.id)"
      (delete)="deleteEditorBlock(item.id)">
    </app-block-style-editor>
  }
}

<app-statistic-list-admin [sectionID]="sectionID()" [showStatistic]="showStatistic"></app-statistic-list-admin>


<!-- AddNewItem -->
@if (isAddingNewBlock) {
  <app-block-style-editor
    [contentBlock]="newEditorBlock"
    [selectedLanguage]="editLanguage"
    (languageChange)="editLanguage = $event"
    (save)="addEditorBlock()"
    (cancel)="toggleFormVisibility()">
  </app-block-style-editor>
}

@if (!isAddingNewBlock && combinedContent.length < 1) {
  <button mat-icon-button (click)="toggleFormVisibility()">
    <mat-icon><span class="material-symbols-outlined">add</span></mat-icon>
  </button>
}
